import {Typography} from "@mui/material";

export const DashboardHeader = ({text}: { text: string }) => {
    return (
        <Typography variant="h4">{text}</Typography>
    )
}